import { useTranslation } from 'react-i18next'

import { TopCourtReportModel } from '../../../../../types/court/court'
import {
  createNumberFormatter,
  createPercentFormatter,
} from '../../../../../utils/locale/localeUtils'

interface TopCourtsProps {
  courts: TopCourtReportModel[]
  locale: string
}

export const TopCourts = ({ courts, locale }: TopCourtsProps) => {
  const { t } = useTranslation('reports')

  const numberFormatter = createNumberFormatter(locale)
  const percentFormatter = createPercentFormatter(locale, {
    maximumFractionDigits: 0,
  })

  return (
    <div className="reports-top-courts-content">
      <div className="reports-top-courts-list">
        {courts.map((court, index) => (
          <div key={court.courtName} className="reports-court">
            <div className="ph-row ph-between reports-court-header">
              <div className="reports-court-name">{court.courtName}</div>
              <div className="mono">
                {numberFormatter.format(court.reservations)}{' '}
                <span className="muted">
                  {t('reports.top-courts.reservations')}
                </span>
              </div>
            </div>
            <div className="reports-progress">
              <div
                className={
                  index === 0
                    ? 'reports-progress-value accent'
                    : 'reports-progress-value'
                }
                style={{ width: `${court.fillRate}%` }}
              />
            </div>
            <div className="mono tiny muted">
              {t('reports.top-courts.fill-rate', {
                value: percentFormatter.format(court.fillRate / 100),
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
